var PREFIX = 'accountid:';
var UNKNOWN_USER = 'UNKNOWN_USER';
var addPrefix = function addPrefix(content) {
  return content.toLowerCase().startsWith(PREFIX) ? content : "".concat(PREFIX).concat(content);
};
export var mention = function mention(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  if (node.attrs.id === UNKNOWN_USER) {
    return "[~".concat(node.attrs.id, "]");
  }
  var mentionKey = node.attrs.id.toLowerCase();
  var content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : addPrefix(node.attrs.id);
  return "[~".concat(content, "]");
};